import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";

const AddJobRole = ({ show, onClose, onCreated, refresh }) => {
    const [jobroleName, setJobroleName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [deptOpt, setDeptOpt] = useState([]);
    const [selDept, setSelDept] = useState(null);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/get_department`);
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.department_name,
                }));
                setDeptOpt(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        fetchLeadTypes();
    }, []);

    const [subdeptOpt, setSubDeptOpt] = useState([]);
    const [selSubDept, setSelSubDept] = useState(null);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/sub_department/get_depts/${selDept}`);
                const formatted = response.data.map(item => ({
                    value: item.sno,
                    label: item.sub_department_name,
                }));
                setSubDeptOpt(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        if(selDept){
            fetchLeadTypes();
        }
    }, [selDept]);

    const [levelOPT, setLevelOPt] = useState([]);
    const [selLev, setSelLev] = useState(null);
    useEffect(() => {
        const fetchLeadTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/level/get_active`);
                const formatted = response.data.map(item => ({
                    value: item.sno,
                    label: item.level_name,
                }));
                setLevelOPt(formatted);
            } catch (error) {
                console.log('Error fetching lead types:', error);
            }
        };

        fetchLeadTypes();
    }, []);
    
    // Handle changes in job role name and ensure first letter is uppercase
    const handleNameChange = (e) => {
        let value = e.target.value;
        // Capitalize the first letter
        value = value.charAt(0).toUpperCase() + value.slice(1);
        setJobroleName(value);

        // Clear name length error if input length is under the limit
        if (value.length <= 300) {
            setNameLengthError('');
        }
    };

    // Handle changes in description and ensure first letter is uppercase
    const handleDescriptionChange = (e) => {
        let value = e.target.value;
        // Capitalize the first letter
        value = value.charAt(0).toUpperCase() + value.slice(1);
        setDescription(value);

        // Check the length of the description and set error if exceeds 500
        if (value.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
        } else {
            setDescLengthError('');
        }
    };

    const [data_name, setData] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/jobrole`)
            .then(response => {
                setData(response.data.data.map(mode => mode.jobrole_name.toLowerCase()));
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, []);

    const handleSubmit = () => {
        // Clear previous errors
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');

        if (!selDept) {
            setErrors(prev => ({
                ...prev,
                dept: "This field is required"
            }));
            return;
        }

        if (!selSubDept) {
            setErrors(prev => ({
                ...prev,
                subdept: "This field is required"
            }));
            return;
        }

        if (!selLev) {
            setErrors(prev => ({
                ...prev,
                level: "This field is required"
            }));
            return;
        }

        // Validation for job role name
        if (!jobroleName) {
            setErrors(prev => ({
                ...prev,
                jobrole_name: "This field is required"
            }));
            return;
        } else if (data_name.includes(jobroleName.trim().toLowerCase())) {
            setErrors(prev => ({
                ...prev,
                jobrole_name: "This Name Already Exists"
            }));
            return;
        }


        // Validation for length of job role name
        if (jobroleName.length > 255) {
            setNameLengthError('Limit reached (max 300 characters)');
            return;
        }

        if (description.length > 255) {
            setDescLengthError('Limit reached (max 500 characters)');
            return;
        }

        // Proceed with API call if validation passes
        axios.post(`${baseURL}/jobrole`, {
            department_id: selDept,
            sub_department_id: selSubDept,
            level_id: selLev,
            jobrole_name: jobroleName,
            description: description,
        })
            .then(() => {

                refresh();
                onClose();
                if (onCreated) onCreated(); // Refresh list after add
                toast.success("Job Role Created successfully!");
            })
            .catch(error => {
                if (error.response?.status === 400) {
                    // Check if the error response contains a message about the job role already existing
                    if (error.response.data?.message === 'Job Role Already Exists.') {
                        setErrors(prev => ({
                            ...prev,
                            jobrole_name: 'Job Role with this name already exists'
                        }));
                    } else if (error.response.data.errors) {
                        // Handle other validation errors
                        setErrors(error.response.data.errors);
                    }
                } else {
                    console.error("Create failed:", error);

                }
            });
    };

    return (

        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Job Role</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Department <span className="required">*</span></label>
                            <Select placeholder="Select Department"
                                options={deptOpt}
                                onChange={(e) => setSelDept(e.value)}
                            />
                            {errors.dept && (
                                <div className="text-danger">{errors.dept}</div>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Sub Department <span className="required">*</span></label>
                            <Select placeholder="Select Sub Department"
                                options={subdeptOpt}
                                onChange={(e) => setSelSubDept(e.value)}
                            />
                            {errors.subdept && (
                                <div className="text-danger">{errors.subdept}</div>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Level <span className="required">*</span></label>
                            <Select placeholder="Select Level"
                                options={levelOPT}
                                onChange={(e) => setSelLev(e.value)}
                            />
                            {errors.level && (
                                <div className="text-danger">{errors.level}</div>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Job Role Name <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control `}
                                placeholder="Enter Job Role Name"
                                value={jobroleName}
                                onChange={handleNameChange}
                            />
                            {errors.jobrole_name && (
                                <div className="text-danger">{errors.jobrole_name}</div>
                            )}
                            {nameLengthError && (
                                <span className="text-danger">{nameLengthError}</span>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={4}
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Job Role
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </Modal>

    );
};

export default AddJobRole;
